import React from 'react';
import Button from 'common/components/Button';

interface Props {
  buttonComponent: React.ReactNode;
  className: string;
  offerings?: [];
  onClick(): void;
}

export const AddMultipleOfferingsToCartButton: React.FC<Props> = props => {
  if (props.offerings.length === 0) return null;

  const ButtonComponent = props.buttonComponent || Button;

  return (
    <ButtonComponent onClick={props.onClick} className={props.className}>
      {props.children}
    </ButtonComponent>
  );
};
